import tools from '../tools.js'
const Position = require('./Position').default;

function Point(el, handler) {
    this.el = el;
    this.id = el.getAttribute('id');
    this.handler = handler;
    this.labelEl = this.handler.el.querySelector('.point-label.' + this.id);

    this.active = false;
    this.position = null;
    this.r = 10;

}

Point.prototype.init = function() {

    let mouseenterHandler = () => {
        this.active = true;
        this.labelEl.classList.add('active');
        this.el.classList.add('active');
        this.el.setAttribute('r', this.r * 1.5);
        // this.handler.triggerEventAnim(this);
    }

    let mouseleaveHandler = () => {
        this.active = true;
        this.labelEl.classList.remove('active');
        this.el.classList.remove('active');
        this.el.setAttribute('r', this.r);
        // this.handler.releaseEventAnim(this);
    }

    this.el.addEventListener('mouseleave', mouseenterHandler);
    this.labelEl.addEventListener('mouseenter', mouseenterHandler);
    this.el.addEventListener('mouseleave', mouseleaveHandler);
    this.labelEl.addEventListener('mouseleave', mouseleaveHandler);

    tools.doOnWindowResize({arg: this, fn: arg => {
            arg.setLabelPosition(arg.getPos());
        }
    })
}

Point.prototype.setDiam = function (diam=10) {
    this.r = diam;
};

Point.prototype.setInitialPosition = function(position= new Position()) {
    this.setPosition(position);
    if(this.labelEl) {
        this.setLabelPosition(position);
        this.setLabelOffset();
    }
}

Point.prototype.setLabelPosition = function(position = new Position()) {
    if(this.labelEl) {
        this.labelEl.style.top = (position.getY() / 776 * this.handler.circleWrapperEl.offsetHeight) + 'px';
        this.labelEl.style.left = (position.getX() / 776 * this.handler.circleWrapperEl.offsetHeight) + 'px';
    }
}

Point.prototype.setLabelOffset = function() {
    if(this.position.getY() < this.handler.circleWrapperEl.offsetHeight * 0.53) {
        this.labelEl.classList.add('over');
    } else {
        this.labelEl.classList.add('under');
    }
    if(this.position.getX() < this.handler.circleWrapperEl.offsetWidth * 0.3) {
        this.labelEl.classList.add('left');
    } else if(this.position.getX() > this.handler.circleWrapperEl.offsetWidth * 0.7) {
        this.labelEl.classList.add('right');
    } else {
        this.labelEl.classList.add('center');
    }
}

Point.prototype.setPosition = function(position=new Position()) {
    this.position = position;
}

Point.prototype.display = function() {
    this.moveToPosition();
    this.el.setAttribute('r', this.r);
    this.el.setAttribute('fill', 'black');
}

Point.prototype.moveToPosition = function() {
    this.el.setAttribute('cx', this.position.getX());
    this.el.setAttribute('cy', this.position.getY());
    if(this.labelEl) {
        this.setLabelPosition(this.position)
    }
}

Point.prototype.getId = function() {
    return this.id;
}

Point.prototype.equals = function(point= new Point()) {
    return this.id === point.id;
}

Point.prototype.getPos = function() {
    return this.position;
}

Point.prototype.animate = function() {
    this.moveToPosition()
}

Point.prototype.stop = function() {}

export default Point;
